<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Parametri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i parametri per l'importazione</span>
              <span v-else-if="modelloDato" key="1">
                {{ modelloDato && modelloDato.descrizione }} | {{nomeFile}} | {{ riferimento }}
              </span>
            </v-col>
            <v-col cols="12" sm="6" class="d-none d-md-block"></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around" dense>
          <v-col cols="12" sm="6">
            <v-select v-model="modelloDato" :items="modelliDato" dense flat outlined label="Modello" item-text="descrizione" item-value="codice" clearable :return-object="true" @change="onChangeModello"></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn @click.stop="onDownloadExcelModello" outlined :disabled="!this.modelloItem">Scarica XLS modello</v-btn>
          </v-col>       
<!--           <v-col cols="12" sm="6">
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataFormatted"
                  label="Data movimento"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="dataMovimento = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataMovimento" no-title scrollable @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col> -->
        </v-row>
<!--           <v-row justify="space-around" dense>
            <v-col cols="12" sm="6">
              <v-select v-model="fornitore" :items="fornitori" dense flat outlined required label="Fornitore" item-text="ragioneSociale" item-value="codice" clearable :return-object="true"></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-switch
              v-model="aggiornaCategorie"
              inset
              dense
              label="Esegui aggiornamento attributi al termine dell'importazione"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
        </v-row> -->
        <v-row justify="space-around" dense>
          <v-col cols="12" sm="6">
            <excel :modelloItem="modelloItem" :resetFile="triggerReset" @onLoaded="onloaded" :disabled="!modelloDato"/>
          </v-col>
          <v-col  cols="12" sm="3">
            <v-switch
              v-model="mostaRaw"
              inset
              dense
              label="Mostra dati file (non elaborati)"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="3">
            <v-switch
              v-model="aggiornaCategorie"
              inset
              dense
              label="Esegui aggiornamento attributi al termine dell'importazione"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row justify="end" dense>
          <v-col cols="12" sm="6">
            <v-text-field v-model="riferimento" dense outlined required label="Riferimento" clearable></v-text-field>
          </v-col>
          <v-col>
            <v-btn @click.stop="onPulisci" :disabled="pulisciDisabled" outlined>Pulisci</v-btn>
          </v-col>          
          <v-spacer/>
          <v-col>
            <v-btn :loading="loading" @click.stop="onImporta" :disabled="importaDisabled">Importa dati</v-btn>
          </v-col>
          <v-col>
            <v-btn :loading="loadingCategorie" @click.stop="onAggiornaCategorie" :disabled="aggiornaCategorie">Aggiorna Attributi</v-btn>
          </v-col>          
        </v-row>
        <dialog-conferma
          :show="dialogConferma"
          title="Confermi import dati ?"
          @dialog-confirm="eseguiImporta"
          @dialog-cancel="dialogConferma=false"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import configurazioni from '@/services/configurazioniService.js'
  import DialogConferma from '@/components/dialogConferma'
  import Excel from './excel.vue'
  import excelService from '@/services/excelService'
  import { sanitize } from '@/components/helpers'

  export default {
    components: {
      Excel,
      DialogConferma
    },
    props: {
      loading: Boolean,
      loadingCategorie: Boolean
    },
    data: (vm) => ({
      panel: 0,
      modelliDato: [],
/*       dataFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataMovimento: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), */
      modelloDato: null,
      modelloItem: null,
      fornitore: null,
/*       fornitoreItem: null, */
      riferimento: '',
      aggiornaCategorie: true,
      menuStart: false,
      modal: false,
      mostaRaw: false,
      totaleDati: 0,
      nomeFile: '',
      dialogConferma: false,
      triggerReset: 0
    }),
    async mounted() {
      const modelli = await configurazioni.getConfigurazione('import_dati', 'modelli')
      this.modelliDato = modelli.generici
      // ...
    },
    computed: {
/*       unionFiltri() {
        return this.fornitore
      }, */
/*       computedDataFormatted () {
        return this.formatDate(this.dataMovimento)
      }, */
      importaDisabled() {
        return !this.riferimento || !this.modelloItem || this.totaleDati === 0 || this.mostaRaw
      },
      pulisciDisabled() {
        return this.loading || this.loadingCategorie
      }
    },
    watch: {
/*       dataMovimento (val) {
        this.dataFormatted = this.formatDate(this.dataMovimento)
      }, */
      mostaRaw(val) {
        this.$emit('cambiaVista', val)
      }
    },
    methods: {
      onChangeModello(modello) {
        // const modello = this.modelliDato.find(x => x.codice === value)
        this.modelloItem = modello
        this.$emit('changeModello', modello)
      },
/*       onFornitoreChanged(item) {
        this.fornitoreItem = item
      }, */
      onloaded(dati) {
        this.totaleDati = dati ? dati.datiModello.length : 0
        if (!this.riferimento && dati) {
          const nn = dati.nomeFile.split('.')
          nn.pop()
          this.riferimento = nn.join('.')
        }
        this.nomeFile = dati ? dati.nomeFile : ''
        this.$emit('onLoaded', dati)
      },
      onPulisci() {
        // this.modelloDato = null
        this.triggerReset++
        // this.fornitore = null
        this.riferimento = ''
        this.$emit('onLoaded', null)
      },
      onImporta() {
        this.dialogConferma = true
      },
      eseguiImporta() {
        const infoImport = {
          riferimento: this.riferimento
        }
        this.$emit('importa', infoImport)        
        this.dialogConferma = false
      },
      onAggiornaCategorie() {
        this.$emit('aggiornaCategorie')
      },      
      async onDownloadExcelModello() {
        const modello = this.modelloItem
        let colonne = {}
        for (let c of modello.colonne) {
          const nome = c.label || c.campo
          colonne[nome] = ''
        }
        
        await excelService.creaExcelData([colonne], `Modello_${sanitize(modello.descrizione)}.xlsx`)
      }
    }
  }
</script>
